module.exports = __webpack_public_path__ + "static/shape-a4ae7cd2344f4498bf1347c0b2ae73fd.png";